import React from 'react';
import styled from 'styled-components';

// Components
import Text from 'components/Text';

// Theme
import { colors } from 'theme/theme';

// img
import logo from '../../images/CAC-badge.svg';

// style
// import './Footer.scss';

const Container = styled.div`
  width: 100%;
  padding: 25px 0;
`;

const Footer = React.memo(() => (
  <Container>
    <div className="d-flex justify-content-center mb-2">
      <a href="https://onlineada.com/certified/2113">
        <img height={35} width={35} src={logo} alt="Academic HealthPlans" />
      </a>
    </div>
    <Text lineHeight="1.36" color={colors.brownGrey} className="text-center mb-1">
      © Academic HealthPlans, Inc.
    </Text>
    <Text lineHeight="1.36" color={colors.brownGrey} className="text-center">
      16201 West 95th Street, Ste. 210 • Lenexa, Ks 66219 • Phone/Fax: 877-974-7462 • E-mail:
      {' '}
      <a href="mailto:sportscare@ahpcare.com">sportscare@ahpcare.com</a>
    </Text>
  </Container>
));

export default Footer;
